import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrModeloModel extends PadraoModel {
  recurso = 'usadosbr/modelos';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Modelos Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor (marca) {
    super()
    this.formLimpo = Object.assign({}, this.form)
    if (marca) this.recurso += `/${marca}`
  }
}
